import axios from 'axios';

const route = window._env_.REACT_APP_WCIBAPI_URL || '';

export const logout = () => new Promise((resolve) => {
    axios.get(`${route}/v1/logout`).then((response) => {
        if (response && response.data === 'ok') {
            return resolve(true);
        } else if (response.code === 401) { // You're also logged out if you're not allowed to logout
            return resolve(true);
        }
    }).catch((error) => { // If you cant reach the server, are you still logged in? maybe but lets throw back to login to be sure
        if (error.response.status === 401) {
            return resolve(true);
        }
        console.log('Error: couldnt reach server' + error);
        return resolve(true);
    });
});

export const requestValidateEmail = (token) => new Promise((resolve, reject) => {
    axios.post(`${route}/v1/emailVerification`, { token }).then((response) => {
        if (response && response.data === 'ok') {
            resolve(true);
        } else {
            reject(response.data);
        }
    }).catch(err => {
        if (err.response.data) {
            reject(err.response.data);
        } else {
            reject(err.message);
        }
    });
});

export const requestAccount = (form) => new Promise((resolve, reject) => {
    axios.post(`${route}/v1/accountRequest?sendemail=true`, form).then((response) => {
        if (response && response.data.status === 'ok') {
            resolve(true);
        } else {
            reject(response.data);
        }
    }).catch(err => {
        if (err.response.data) {
            reject(err.response.data);
        } else {
            reject(err.message);
        }
    });
});

export const fileList = () => new Promise((resolve, reject) => {
    axios.get(`${route}/v1/list`).then((response) => {
        if (response.data) {
            resolve(response.data);
        }
    }).catch((error) => {
        console.log('Error: couldnt reach server' + error);
        return reject(error);
    });
});
export const login = (values) => new Promise((resolve, reject) => {
    axios.post(`${route}/v1/login?sendemail=true`, values).then((response) => {
        // /v1/login returns the user payload as JSON: { username, organization,
        // groups, authMethod, canCreateDataset }. Older deployments returned the
        // string 'ok' — accept that too so a frontend rolled forward against an
        // older API still works (degraded: no canCreateDataset → Admin tab
        // creator gate is disabled until next /validatesession). Anything else
        // is treated as an error.
        const data = response.data;
        if (data && typeof data === 'object' && data.username) {
            console.log('logged in ok');
            resolve(data);
        } else if (data === 'ok') {
            console.log('logged in ok (legacy text response)');
            resolve({ username: values.username, canCreateDataset: false, groups: [] });
        } else {
            console.log('Login: ', data);
            reject(response);
        }
    }).catch((error) => {
        if (error.response) {
            console.error('Login: ', error.response);
            reject(error.response);
        } else if (error.request) {
            console.error('Login: ', error.request);
            reject(error.request);
        } else {
            reject(error);
        }
    });
});

export const isLoggedIn = () => new Promise((resolve, reject) => {
    // /v1/validatesession returns the user payload (same shape as /v1/login)
    // when the session cookie is valid, 401 otherwise. Frontend uses this on
    // boot to hydrate Redux for users who landed via OAuth/OIDC redirect or
    // are returning with a still-valid cookie after a reload.
    axios.get(`${route}/v1/validatesession`).then(resolve).catch(reject);
});

export const meta = (search) => new Promise((resolve, reject) => {
    const newroute = `${route}/v1/meta${search ? `=search=${search}` : ''}`;
    axios.get(newroute).then(resolve).catch(reject);
});
export const putQuery = (query) => new Promise((resolve, reject) => {
    axios.put(`${route}/v1/query`, query).then((response) => {
        resolve(response.data);
    }).catch(reject);
});

export const query = (query) => new Promise((resolve, reject) => {
    axios.get(`${route}/v1/query?id=${query}`).then((response) => {
        resolve(response.data);
    }).catch((error) => {
        console.log('Error: couldnt reach server' + error);
        reject(error);
    });
});

export const distinct = (type) => new Promise((resolve, reject) => {
    axios.get(`${route}/v1/distinct?field=${type}`).then((response) => {
        if (response.data) {
            resolve(response.data);
        }
    }).catch((error) => {
        console.log('Error: couldnt reach server' + error);
        reject(error);
    });
});

export const generateToken = (daystolive, options = {}) => new Promise((resolve, reject) => {
    const params = new URLSearchParams({ expires: daystolive });
    const body = {};
    if (options.name) body.name = options.name;
    if (options.api) body.api = options.api;
    if (options.mqtt) body.mqtt = options.mqtt;

    axios.post(`${route}/v1/generatetoken?${params}`, body).then(resolve).catch(reject);
});

export const getMyHistory = () => new Promise((resolve, reject) => {
    axios.get(`${route}/v1/history`).then((response) => resolve(response.data)).catch((err) => {
        console.error(err);
        reject(err);
    });
});
export const getMyQueries = () => new Promise((resolve, reject) => {
    axios.get(`${route}/v1/myqueries`).then((response) => resolve(response.data)).catch((err) => reject(err));
});

export const createQueryGetString = (query) => {
    return `${route}/v1/query?id=${query}`;
};

export const getFaq = () => new Promise((resolve, reject) => {
    axios.get(`${route}/v1/faq`).then((response) => resolve(response.data)).catch((error) => {
        console.log('Error: couldnt reach server' + error);
        reject(error);
    });
});
